<template>
  <div class="channel-grid">
    <el-tooltip effect="dark" :content="tooltip" placement="top-start">
      <a
        :style="'background-image: url(\''+thumbnail+'\')'"
        class='thumbnail'
        @click.prevent="handleClick(id)"
        :href='httpChannelUrl'
      ></a>
    </el-tooltip>
    <div>
      <a @click.prevent="handleClick(id)" :href='httpChannelUrl'>
        <span>{{ title }}</span>
      </a>
    </div>
  </div>
</template>

<script>
import { httpUrl } from '../app/config'
import { getAuthKey } from '../app/helpers';

export default {
  props: [
    'title',
    'thumbnail',
    'id',
    'tooltip',
    'category',
    'toHttp'
  ],

  data() {
    return {
      httpUrl,
    }
  },

  mounted() {},


  methods: {
    handleClick(id) {
      if (this.toHttp) {
        window.location.href = this.httpChannelUrl;
      } else {
        this.$router.push({
          name: 'live.stream',
          params: {
            id
          }
        });
      }
    }
  },


  computed: {
    httpChannelUrl() {
      const router = this.$router.resolve({
        name: 'live.stream',
        params: {
          id: this.id
        }
      });

      return this.httpUrl + router.href
        + '?__k=' + getAuthKey();
    }
  }
}
</script>


<style lang="scss" scoped>
.thumbnail {
    width: 110px;
    height: 110px;
    display: block;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    background-color: white;
    border-radius: 2px 2px;
    margin: 0px auto 10px;

    @media (max-width: 420px) {
      width: 90px;
      height: 90px;
    }
}

.channel-grid > div {
    text-align: center;
    color: white;
}

.channel-grid > div  a {
    color: white;
    font-size: 14px;
    max-width: 130px;
    display: block;
    margin: 0px auto;
    text-align: center;

    @media (max-width: 420px) {
      max-width: 110px;
    }
}

.channel-grid:hover a {
    color: #f9443e;
    transition-duration: .3s;
    text-decoration: none;
}
</style>